<template>
  <div class="main-configuracionPicking">
    <f7-popup
      v-model:opened="opened"
      class="popupConfiguracionPicking"
    >
      <f7-navbar
        :title="t('common.configuration')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="opened = false">
            <img :src="icClose">
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <div>
        <!-- Cabecera Formulario -->
        <div class="div-popupConfiguracionPicking">
          <span class="content-title"> {{ t('common.configurationParameters') }} </span>
          <div class="content-params">
            <span class="content-params__title">
              {{ t('commercialization.common.boxesReading') }}
            </span>
            <UCCodeScannerConfig
              ref="codeScannerConfigReadBoxRef"
              title=""
              :config="configuracionLecturaCajasFrmPicking"
            />
          </div>
        </div>

        <div class="div-opcionesActions">
          <f7-row style="line-height: 10px;">
            <f7-col
              width="50"
              class="col-izquierdaActions"
            >
              <a
                class="link link-izquierdaActions-2"
                @click="handleCancel"
              >
                {{ t('common.cancel').toUpperCase() }}
              </a>
            </f7-col>
            <f7-col
              width="50"
              class="col-derechaActions"
            >
              <a
                class="link link-derechaActions-2"
                @click="handleConfirmation"
              >
                {{ t('common.confirm').toUpperCase() }}
              </a>
            </f7-col>
          </f7-row>
        </div>
      </div>
    </f7-popup>
  </div>
</template>

<script setup>
// @ts-check
import { useSettingRef } from '@erpagroapp/settings';
import icClose from '@/static/icons/ic_close.svg';
import UCCodeScannerConfig from '@/components/common/UCCodeScannerConfig.vue';
import { reactive, shallowRef } from 'vue';
import { useI18n } from 'vue-i18n';

/** @import { ShallowRef } from 'vue' */

const opened = defineModel('opened', {
  type: Boolean,
  default: false,
});

const appTheme = {
  '--f7-navbar-bg-color': 'var(--his-plum-shadow)',
  '--f7-navbar-text-color': '#fff',
};

const { t } = useI18n();
const configuracionLecturaCajasFrmPicking = reactive({
  LecturaContinuaCodigosBarras: useSettingRef('Picking.LecturaCajas.LecturaContinuaCodigosBarras'),
  LecturaContinuaCodigosBarrasManual: useSettingRef('Picking.LecturaCajas.LecturaContinuaCodigosBarrasManual'),
  UtilizarFlash: useSettingRef('Picking.LecturaCajas.UtilizarFlash'),
  OrientacionCamaraLecturaCodigos: useSettingRef('Picking.LecturaCajas.OrientacionCamaraLecturaCodigos'),
  LecturaEnTraspaso: useSettingRef('Picking.LecturaCajas.LecturaEnTraspaso'),
});
/** @type {ShallowRef<InstanceType<typeof UCCodeScannerConfig> | null>} */
const codeScannerConfigReadBoxRef = shallowRef(null);

function handleCancel() {
  resetValues();
}

function handleConfirmation() {
  const lecturaCajasConfig = codeScannerConfigReadBoxRef.value?.getNewConfig();
  if (lecturaCajasConfig) {
    configuracionLecturaCajasFrmPicking.LecturaContinuaCodigosBarras = lecturaCajasConfig.LecturaContinuaCodigosBarras;
    configuracionLecturaCajasFrmPicking.LecturaContinuaCodigosBarrasManual = lecturaCajasConfig.LecturaContinuaCodigosBarrasManual;
    configuracionLecturaCajasFrmPicking.UtilizarFlash = lecturaCajasConfig.UtilizarFlash;
    configuracionLecturaCajasFrmPicking.OrientacionCamaraLecturaCodigos = lecturaCajasConfig.OrientacionCamaraLecturaCodigos;
    configuracionLecturaCajasFrmPicking.LecturaEnTraspaso = lecturaCajasConfig.LecturaEnTraspaso;
  }
  opened.value = false;
}

function resetValues() {
  codeScannerConfigReadBoxRef.value?.initialize();
  opened.value = false;
}
</script>

<style lang="scss">
.popupConfiguracionPicking {
  background: #fff;

  .div-popupConfiguracionPicking {
    margin: 10px;

    .content-title {
      color: #8e8e93;
      font-size: 16px;
    }

    .content-params {
      padding-left: 10px;
      padding-top: 20px;

      &__title {
        color: #8e8e93;
      }

      &__list {
        margin-top: var(--f7-block-margin-vertical);
        margin-left: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-left));
        margin-right: calc(var(--f7-block-padding-horizontal) + var(--f7-safe-area-right));
      }

      .main-uc-code-scanner-config {
        .block-title {
          margin-top: 0;
        }
      }
    }
  }

  .div-opcionesActions {
    width: 94%;
    left: 0;
    bottom: 0;
    position: absolute;
    padding-bottom: 13px;
    z-index: 2;
  }
}
</style>
